module.exports = __webpack_public_path__ + "img/2.b0d2d2fd.png";